import angular from "angular"
import "./dashboard.component.css"

const templateUrl = require("ngtemplate-loader!html-loader!./dashboard.component.html")
const descargablesUrl = require("file-loader!./formularios/descargables.html")

angular.module("appModule").directive("sampleDirective", [
  "$timeout",
  function($timeout) {
    return {
      scope: {
        difference: "="
      },
      link: function(scope, element, attrs) {
        scope.display = 0

        scope.$watch("difference", function(newVal, oldVal) {
          jQuery({ someValue: oldVal }).animate(
            { someValue: newVal },
            {
              duration: 500,
              easing: "swing",
              step: function(e) {
                $timeout(function() {
                  scope.$apply(function() {
                    scope.display = e.toFixed()
                  })
                })
              }
            }
          )
        })
      },
      template: function(scope, element, attrs) {
        return "<span>{{ display | number }}</span>"
      }
    }
  }
])

DashBoardController.$inject = [
  "$q",
  "store",
  "statsService",
  "formularioService",
  "SedeService",
  "JornadaService",
  "EscuelaService",
  "CarreraService"
]
function DashBoardController(
  $q,
  store,
  statsService,
  formularioService,
  SedeService,
  JornadaService,
  EscuelaService,
  CarreraService
) {
  var self = this

  self.loading = false

  self.message = "Hello from AngularJS"

  // Isstitution code, so we show or hide some metrics
  self.institution_code = store.get("user").institution_code || ""

  // For cuc.co we HIDE the first chart (desertion metric)
  // This is temporal solution. A more fleshed out solution would involve
  // writing some kind of "feature hub" or some, central, unique place
  // where to store all the flips/switches the app supports and then writing
  // the handling of those flips for each customer.
  self.show_first_chart = true

  // Handle cuc.co
  if (self.institution_code == "cuc.co") {
    self.show_first_chart = false
  }

  // First chart:
  self.labels = ["Desertores", "No Desertores"]
  self.data = [0, 0]
  self.colors = ["#E33932", "#EDECEC"]
  self.options = {
    responsive: true,
    maintainAspectRatio: false,
    cutoutPercentage: 75,
    pieceLabel: {
      render: function(args) {
        if (args.label == "No Desertores") {
          return ""
        }

        // args = {label: "Pendientes", value: 40, percentage: 20, dataset: {…}, index: 2}
        return args.label
      },
      position: "outside",
      overlap: false,
      fontSize: 12,
      fontColor: function(args) {
        return "#E33932"
      },
      fontFamily: 'Roboto, "Helvetica Neue", sans-serif'
    },
    plugins: {
      p1: {
        enabled: true,
        text_height_scale: 120
      }
    },
    layout: {
      padding: 25
    },
    elements: {
      arc: {
        borderWidth: 0
      }
    }
  }
  self.initial_number_of_students = 0
  self.number_of_deserters = 0
  self.desertion_level_items = [
    // {
    //   'percentage': 10,
    //   'count': 123,
    //   'label': "Financiero",
    // }
  ]
  self.dataset_override = {
    backgroundColor: ["#ff5f58", "#EDECEC"],
    hoverBackgroundColor: ["#e33932", "#e0e0e0"]
    // hoverBorderColor: [],
  }

  // Second chart
  self.labels2 = ["En atención", "Sin atención", "Sin alerta activa"]
  self.data2 = [0, 0, 0]
  self.colors2 = ["#F4CA3E", "#ED9259", "#EDECEC"]
  self.options2 = {
    responsive: true,
    maintainAspectRatio: false,
    cutoutPercentage: 75,
    legend: {
      display: false,
      position: "bottom"
    },
    pieceLabel: {
      render: function(args) {
        // Hide labels when percentage is too small
        if (args.percentage < 2) {
          return ""
        }

        if (args.label == "Sin alerta activa") {
          return ""
        } else if (args.label == "Sin atención") {
          return "      Sin atención"
        }
        // args = {label: "Pendientes", value: 40, percentage: 20, dataset: {…}, index: 2}
        return args.label
      },
      position: "outside",
      overlap: false,
      fontSize: 12,
      fontColor: function(args) {
        if (args.label == "En atención") {
          return "#F4CA3E"
        } else if (args.label == "Sin atención") {
          return "#ED9259"
        } else {
          return "#EDECEC"
        }
      },
      fontFamily: 'Roboto, "Helvetica Neue", sans-serif'
    },
    plugins: {
      p1: {
        enabled: true,
        text_height_scale: 120
      }
    },
    layout: {
      padding: 25
    },
    elements: {
      arc: {
        borderWidth: 0
      }
    }
  }
  self.number_of_students_with_alert = 0
  self.number_of_active_students = 0
  self.number_of_alerts_by_type = [
    // {
    //   'count': 123,
    //   'label': "Financiero",
    // }
  ]
  self.dataset_override2 = {
    backgroundColor: ["#f3ca3e", "#ffaa36", "#f2f2f2"],
    hoverBackgroundColor: ["#e6b408", "#f28c02", "#e0e0e0"]
    // hoverBorderColor: [],
  }

  // Third chart
  self.labels3 = ["A"]
  self.data3 = [0]
  self.colors3 = ["#6CBE9C", "#EECA4A", "#F0534F"]
  self.options3 = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      p2: {
        enabled: true
      }
    },
    tooltips: {
      enabled: false
    },
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      yAxes: [
        {
          display: false,
          gridLines: {
            display: false
          },
          barPercentage: 1.0,
          categoryPercentage: 1.0
        }
      ],
      xAxes: [
        {
          display: false,
          ticks: {
            suggestedMin: 0, // minimum will be 0, unless there is a lower value.
            suggestedMax: 100
          },
          gridLines: {
            display: false
          },
          barPercentage: 1.0,
          categoryPercentage: 1.0
        }
      ]
    }
  }
  self.dataset_override3 = {
    backgroundColor: ["#6CBE9C", "#EECA4A", "#F0534F"],
    hoverBackgroundColor: ["#449c77", "#EECA4A", "#F0534F"]
    // hoverBorderColor: [],
  }

  self.number_of_carried_out_attentions = 0
  self.total_number_of_attentions = 0
  self.number_of_attentions_carried_out_by_type = [
    // {
    //   'percentage': 67,
    //   'total': 123,
    //   'label': "Financiero",
    // }
  ]
  self.desertion_grouping_text = "SEDES CON DESERCIÓN"

  self.filtersToLoad = {
    sede: true,
    escuela: false,
    jornada: false,
    carrera: false
  }

  self.filterForward = {
    sede: ["escuela"],
    escuela: ["carrera"],
    carrera: ["jornada"],
    jornada: []
  }

  self.services = {
    sede: SedeService,
    jornada: JornadaService,
    escuela: EscuelaService,
    carrera: CarreraService
  }

  self.sede_id = -1
  self.escuela_id = -1
  self.jornada_id = -1
  self.carrera_id = -1

  self.sedes = []
  self.jornadas = []
  self.escuelas = []
  self.carreras = []

  self.$onInit = function() {
    self.loadFilters()
  }

  self.getParams = function() {
    var params = {}
    if (self.sede_id !== -1) {
      params["sede_id"] = self.sede_id
    }
    if (self.escuela_id !== -1) {
      params["escuela_id"] = self.escuela_id
    }
    if (self.jornada_id !== -1) {
      params["jornada_id"] = self.jornada_id
    }
    if (self.carrera_id !== -1) {
      params["carrera_id"] = self.carrera_id
    }
    return params
  }

  self.getModels = function(model, params) {
    var d = $q.defer()
    var data = self.services[model].get(params, function() {
      d.resolve({ model: model, results: data.results })
    })
    return d.promise
  }

  self.loadFilters = function() {
    var model
    var array_aux
    var queryArray = []
    var params = self.getParams()
    var models = Object.keys(self.filtersToLoad)

    for (var i = 0; i < models.length; i++) {
      model = models[i]
      if (self.filtersToLoad[model]) {
        queryArray.push(self.getModels(model, params))
      }
    }

    $q.all(queryArray).then(function(data) {
      var model
      for (var i = 0; i < data.length; i++) {
        model = data[i]["model"]
        switch (model) {
          case "sede":
            self.sedes = data[i]["results"]
            break
          case "jornada":
            self.jornadas = data[i]["results"]
            break
          case "escuela":
            self.escuelas = data[i]["results"]
            break
          case "carrera":
            self.carreras = data[i]["results"]
            break
        }
      }
      self.loadIndicadores()
    })
  }

  self.filterChange = function(model, value) {
    // By default, do not load any filter
    self.filtersToLoad["sede"] = false
    self.filtersToLoad["escuela"] = false
    self.filtersToLoad["jornada"] = false
    self.filtersToLoad["carrera"] = false

    // Load every forward filter
    for (var i = 0; i < self.filterForward[model].length; i++) {
      self.filtersToLoad[self.filterForward[model][i]] = true
    }

    self.clearForwardFilter(model)

    self.loadFilters()
  }

  self.clearForwardFilter = function(model) {
    // Load every forward filter
    for (var i = 0; i < self.filterForward[model].length; i++) {
      var forward_model = self.filterForward[model][i]

      // Clear
      switch (forward_model) {
        case "sede":
          self.sede_id = -1
          break
        case "jornada":
          self.jornada_id = -1
          break
        case "escuela":
          self.escuela_id = -1
          break
        case "carrera":
          self.carrera_id = -1
          break
      }

      // And recurse
      self.clearForwardFilter(forward_model)
    }
  }

  self.loadIndicadores = function() {
    var params = self.getParams()

    self.loading = true
    statsService.getStats(params).then(function(data) {
      self.loading = false
      var arreglo = []

      // Desertion
      self.data = [
        data["desertion"]["count"],
        data["desertion"]["total"] - data["desertion"]["count"]
      ]
      self.initial_number_of_students = data["desertion"]["total"]
      self.number_of_deserters = data["desertion"]["count"]
      self.desertion_level_items = data["desertion"]["grouping"]["groups"].map(function(r) {
        return {
          percentage: r.percentage.toFixed(),
          count: r.count,
          label: r.label
        }
      })

      // Alert
      self.data2 = [
        data.alert.number_of_students_by_alert_state.active,
        data.alert.number_of_students_by_alert_state.pending,
        data.alert.number_of_students_by_alert_state.closed
      ]
      self.number_of_students_with_alert =
        data.alert.number_of_students_by_alert_state.active +
        data.alert.number_of_students_by_alert_state.pending
      self.number_of_active_students = data.alert.number_of_students_by_alert_state.total
      self.number_of_alerts_by_type = data.alert.total_alerts_by_type.map(function(r) {
        return {
          count: r.total,
          label: r.label
        }
      })

      // Attention
      self.data3 = [data.attention.percentage.toFixed()]
      self.number_of_carried_out_attentions = data.attention.count
      self.total_number_of_attentions = data.attention.total
      self.number_of_attentions_carried_out_by_type = data.attention.grouping.groups.map(function(
        r
      ) {
        return {
          percentage: r.percentage.toFixed(),
          count: r.count,
          total: r.total,
          label: r.label
        }
      })

      self.desercion = data["desercion"]
      self.estudiantes_total = data["total"]
      self.estudiantes_desertores = data["desertores"]
      self.indicadores = data["indicadores"]

      // Update text of desertion groups
      if (self.sede_id == -1) {
        // nothing selected
        self.desertion_grouping_text = "SEDES CON DESERCIÓN"
      } else if (self.escuela_id == -1) {
        self.desertion_grouping_text = "ESCUELAS CON DESERCIÓN"
      } else if (self.carrera_id == -1) {
        self.desertion_grouping_text = "CARRERAS CON DESERCIÓN"
      } else if (self.jornada_id == -1) {
        self.desertion_grouping_text = "JORNADAS CON DESERCIÓN"
      } else {
        self.desertion_grouping_text = "- SIN AGREGACIÓN DISPONIBLE -"
      }
    })
  }

  self.descargarReporte = function($event) {
    formularioService.showPopupSimple($event, {
      controller: [
        "$scope",
        "$mdDialog",
        "ExportService",
        function($scope, $mdDialog, ExportService) {
          var selfCtrl = $scope
          selfCtrl.isLoading = false
          selfCtrl.reportes = [
            {
              method: "reporteEstudiantesAtendidos",
              nombre: "Reporte Estudiantes"
            },
            {
              method: "reporteAtencionesRealizadas",
              nombre: "Reporte Atenciones"
            },
            {
              method: "reporteAlertasEnCurso",
              nombre: "Reporte Alertas"
            },
            {
              method: "reporteUsuarios",
              nombre: "Reporte Responsables"
            }
          ]

          selfCtrl.descargarReporte = function() {
            if (selfCtrl.reporte_method) {
              var a = document.createElement("a")
              document.body.appendChild(a)

              selfCtrl.isLoading = true

              ExportService[selfCtrl.reporte_method]().then(function(result) {
                var file = new Blob([result.data], {
                  type: result.type
                })
                var fileURL = window.URL.createObjectURL(file)
                a.href = fileURL
                a.download = result.filename
                a.click()
                selfCtrl.isLoading = false
                $mdDialog.hide()
              })
            }
          }

          selfCtrl.cancelar = function() {
            $mdDialog.hide()
          }
        }
      ],
      templateUrl: descargablesUrl
    })
  }
}

angular.module("appModule").component("dashboard", {
  templateUrl: templateUrl,
  bindings: {},
  controller: DashBoardController
})
